import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from 'components/Inputs/TextInput';

export const NameInput = ({
  id,
  name,
  onChange,
  error,
  validate,
  clearError,
}) => {
  const { t } = useTranslation();

  const [stagedName, setName] = useState(name);

  const onChangeName = useCallback(
    (value) => {
      setName(value);
      clearError('name');
    },
    [clearError]
  );
  const onBlurName = useCallback(() => {
    const trimmedName = stagedName.trim();
    onChange(id, 'name', trimmedName);
    setName(trimmedName);
  }, [onChange, stagedName, id]);

  return (
    <TextInput
      value={stagedName}
      label={t('Action Name')}
      placeholder={t('Enter Action Name')}
      onChange={onChangeName}
      onBlur={onBlurName}
      error={error}
      validate={validate}
    />
  );
};
